<template>
	<div class="pe-overlay">
		<div class="backdrop" :class="{ show: show }" @click="$emit('close')"></div>
		<div class="modal save-modal" :class="{ show: show }" role="dialog" aria-modal="true">
			<div class="modal-head"><div>Save view</div><button class="navbtn close" aria-label="Close" @click="$emit('close')"><i class="fa-solid fa-xmark"></i></button></div>
			<div class="save-body">
				<p class="save-hint">Saves the current filters, columns and sort as a reusable tab you can return to.</p>
				<input ref="input" class="save-input" v-model="name" placeholder="View name — e.g. WI municipalities on trial" @keyup.enter="save" />
			</div>
			<div class="modal-foot" style="justify-content:flex-end"><button class="pill" @click="$emit('close')">Cancel</button><button class="btn-primary" :disabled="!name.trim()" @click="save">Save view</button></div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'PeSaveViewModal',
	props: { show: { type: Boolean, default: false } },
	data() {
		return { name: '' }
	},
	watch: {
		show(v) { if (v) { this.name = ''; this.$nextTick(() => { if (this.$refs.input) this.$refs.input.focus() }) } },
	},
	mounted() { if (this.$el.parentNode !== document.body) document.body.appendChild(this.$el) },
	beforeDestroy() { if (this.$el.parentNode) this.$el.parentNode.removeChild(this.$el) },
	methods: {
		save() { const n = this.name.trim(); if (n) this.$emit('save', n) },
	},
}
</script>
